import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDevices = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1795_1918)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M5.67 7.83008L4 9.50008H6L4.33 11.1701",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.5 3.5H3.5V6.5H6.5V3.5Z",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9 7.5H11.5V13.5H13.5V6",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2 12.5H8",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.5 4V3",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.5 4V3",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.5 14.5H1.5V2.33C1.5 1.87 1.87 1.5 2.33 1.5H7.66C8.12 1.5 8.49 1.87 8.49 2.33L8.5 14.5Z",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 4.49C12 5.41 12.77 6.1 13.72 5.98C14.47 5.88 15 5.2 15 4.45V4H12V4.5V4.49Z",
				stroke: "#010101",
				strokeLinejoin: "bevel"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1795_1918",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgDevices;
